var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKrayr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 302,
    viewBox: "0 0 229 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.678 120.228C127.473 116.958 132.527 116.958 135.322 120.228L184.219 177.453C188.101 181.995 184.873 189 178.897 189H81.1029C75.1275 189 71.8993 181.995 75.7811 177.453L124.678 120.228Z",
    fill: "#42979F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 178.555V44.5547C43 37.7547 50.6667 36.7214 54.5 37.0547H170.5C181.3 37.8547 177 46.0547 173.5 50.0547L56.5 183.5C46 198.5 44 186.721 43 178.555Z",
    fill: "#F3926A",
    stroke: "#F3926A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 223,
    height: 222,
    stroke: "#42979F",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.74 300L66.64 288.3H66.16H57.7V300H47.98V258H66.16C69.88 258 73.1 258.62 75.82 259.86C78.58 261.1 80.7 262.86 82.18 265.14C83.66 267.42 84.4 270.12 84.4 273.24C84.4 276.36 83.64 279.06 82.12 281.34C80.64 283.58 78.52 285.3 75.76 286.5L85.18 300H74.74ZM74.56 273.24C74.56 270.88 73.8 269.08 72.28 267.84C70.76 266.56 68.54 265.92 65.62 265.92H57.7V280.56H65.62C68.54 280.56 70.76 279.92 72.28 278.64C73.8 277.36 74.56 275.56 74.56 273.24Z",
    fill: "#42979F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.74 301L206.64 289.3H206.16H197.7V301H187.98V259H206.16C209.88 259 213.1 259.62 215.82 260.86C218.58 262.1 220.7 263.86 222.18 266.14C223.66 268.42 224.4 271.12 224.4 274.24C224.4 277.36 223.64 280.06 222.12 282.34C220.64 284.58 218.52 286.3 215.76 287.5L225.18 301H214.74ZM214.56 274.24C214.56 271.88 213.8 270.08 212.28 268.84C210.76 267.56 208.54 266.92 205.62 266.92H197.7V281.56H205.62C208.54 281.56 210.76 280.92 212.28 279.64C213.8 278.36 214.56 276.56 214.56 274.24Z",
    fill: "#42979F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.14 284.12V299H154.42V284L138.16 257H148.48L159.7 275.66L170.92 257H180.46L164.14 284.12Z",
    fill: "#42979F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.64 290H103.14L99.42 299H89.46L108.18 257H117.78L136.56 299H126.36L122.64 290ZM119.58 282.62L112.92 266.54L106.26 282.62H119.58Z",
    fill: "#42979F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 299V260H10V277H11.5L26.5 260H37L21 278L38 299H27L16 284.5H14L9 289.5V299H1Z",
    fill: "#42979F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrayr);
export default __webpack_public_path__ + "static/media/krayr.64098502ca4d358cd2a40bd3ec1c8dba.svg";
export { ForwardRef as ReactComponent };